import CustomButton from "../../../UIElements/CustomButton";
import { Box, Typography } from "@mui/material";

export default function SucessSubmitDossierToInstructionContent({
    onSucessSubmitDossierToInstruction,
}: {
    onSucessSubmitDossierToInstruction: Function;
}) {
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "2rem",
                flex: "1 0 0",
            }}
        >
            <Typography
                sx={{
                    alignSelf: "stretch",
                    color: "#005499",
                    textAlign: "center",
                    fontFamily: "Roboto",
                    fontSize: "1.75rem",
                    fontQtyle: "normal",
                    fontWeight: 700,
                    lineHeight: "normal",
                }}
            >
                Votre dossier a été soumis !
            </Typography>
            <CustomButton
                onClick={() => {
                    onSucessSubmitDossierToInstruction();
                }}
                label="Terminer"
                customsx={{
                    width: "100%",
                }}
            />
        </Box>
    );
}
